import { Directive, HostListener } from '@angular/core';
import { DialogService } from 'src/app/dialogs/dialog.service';

@Directive({
  selector: '[appSupportLink]',
})
export class SupportLinkDirective {
  constructor(private dialogService: DialogService) {}

  @HostListener('click', ['$event'])
  @HostListener('keydown.enter', ['$event'])
  onClick(event: Event) {
    this.dialogService.openContactDialog();
  }
}
